module.exports = __webpack_public_path__ + "images/noun_send_105496dccf2011e4661d7a7d17127adb55900b.svg";